<style lang="stylus">
    .emptyCloud
        display flex
        justify-content center
        flex-wrap wrap
        font-size 14px !important
        font-weight 500
        position absolute
        top 100px
        left 50%
        transform translate(-50%,0)
        svg
            cursor pointer
        span
            color #222
        .new-animation
          display inline-block
          font-size 16px
          animation btnbor 1.3s ease-out infinite
    @keyframes btnbor {
        0% {
            transform perspective(1px) scale(0.8)
        }
        50% {
            transform scale(1)
        }
        100% {
            transform perspective(1px) scale(0.8)
        }
    }
</style>

<template>
    <div class="emptyCloud" style="width: 250px" v-cloak v-if="pcNoLogin">
        <!-- <iconSymbol name="toLoginIcon"/> -->
        <img src="@/home/assets/img/null-icon/recent-null.svg" alt="" />
        <div style="text-align: center; position: relative">
            <div>{{ $t("tipsPre") }}</div>
            <span>{{ $t("click") }}</span>
            <a class="new-animation" @click="toCreateFile()">【{{ $t("new") }}】</a>
            <span class="tips-end">{{ $t("tipsEnd") }}</span>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component({
        components: {},
    })
    export default class PClogin extends Vue {
        get pcNoLogin() {
            return this.isPC && !this.params.islogin;
        }
        toCreateFile() {
            (<any>window).$qt.jsCallUserLogin();
            // this.$bus.$emit('toCreateFile')
        }
    }
</script>
<i18n>
{
  "zh": {
    "tipsPre": "您还没有云文件；",
    "click": "点击",
    "new": "新建",
    "tipsEnd": ", 开始您的绘图之旅。"
  },
  "en": {
    "tipsPre": "You don't have a cloud file;",
    "click": "click",
    "new": "new",
    "tipsEnd": ", start your drawing journey."
  },
  "fr": {
    "tipsPre": "Vous n'avez pas encore de fichier Cloud;",
    "click": "Cliquez sur",
    "new": "Nouveau",
    "tipsEnd": ",Pour commencer votre voyage de dessin."
  },
  "de": {
    "tipsPre": "Sie haben noch keine Cloud-Datei;",
    "click": "Klick",
    "new": "neu gebaut",
    "tipsEnd": ",Beginnen Sie Ihre Reise."
  },
  "jp": {
    "tipsPre": "クラウドファイルはまだありません。",
    "click": " ",
    "new": "新規作成",
    "tipsEnd": "をクリックして図を作りましょう。"
  },
  "es": {
    "tipsPre": "Aún no tiene un archivo Cloud;",
    "click": "click",
    "new": "Nuevo",
    "tipsEnd": ",Comience su viaje de dibujo."
  },
  "pt": {
    "tipsPre": "Você não tem um arquivo de nuvem ainda;",
    "click": "clique",
    "new": "recém-construída",
    "tipsEnd": ",Comece sua jornada de desenho."
  },
  "it": {
    "tipsPre": "Non hai ancora un file cloud;",
    "click": "click",
    "new": "nuova costruzione",
    "tipsEnd": ",Inizia il tuo viaggio di disegno."
  },
  "tw": {
    "tipsPre": "您還沒有雲文件；",
    "click": "點擊",
    "new": "新建",
    "tipsEnd": ",開始你的繪圖之旅。"
  },
  "kr": {
    "tipsPre": "클라우드 파일이 없습니다.",
    "click": "클릭",
    "new": "새로 만들다",
    "tipsEnd": ", 드로잉 여행을 시작합니다."
  },
  "id": {
    "tipsPre": "Anda tidak memiliki file cloud;",
    "click": "klik",
    "new": "baru",
    "tipsEnd": ", mulai menggambar."
  }
}
</i18n>
